import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, Input, Row, UncontrolledDropdown, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label,Badge
} from 'reactstrap';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { ToastContainer } from 'react-toastify';
import FeatherIcon from "feather-icons-react";
import { getClientList } from '../../../slices/veloxity/client/ClientListReducer';
import { updateClient } from '../../../slices/veloxity/client/ClientUpdateReducer';
import { createClient } from '../../../slices/veloxity/client/ClientCreateReducer';
import { deleteClient } from '../../../slices/veloxity/client/ClientDeleteReducer';
import { clientStatusUpdate } from '../../../slices/veloxity/client/ClientStatusUpdate'; 
import Loader from "../../../components/common/Loader";
import showConfirmationAlert from '../../../components/custom/confirmationAlert';
import { showSuccessAlert,showErrorAlert } from '../../../components/custom/sweetalertHelper';

const CompanyAdmin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, payload: companies, error } = useSelector(state => state.clientList);
    const updateState = useSelector(state => state.updateClient);
    const createState = useSelector(state => state.createClient);
    const deleteState = useSelector(state => state.deleteClient);

    const goToCompanyDetail = (company) => {
        navigate(`/company-detail/${company.id}`, { state: { companyData: company } });
    };

    useEffect(() => {
        if ((updateState.loading === false && !updateState.error) ||
            (createState.loading === false && !createState.error) ||
            (deleteState.loading === false && !deleteState.error)) {
            dispatch(getClientList());
        }
    }, [updateState, createState, deleteState, dispatch]);

    const [company, setCompany] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(12);
    const [searchTerm, setSearchTerm] = useState('');

    const [newCompany, setNewCompany] = useState({
        name: "",
        email: "",
        type: "BASIC",
        base64Image: "",
        employees: []
    });

    const onClickData = (company) => {
        setCompany(company);
        setDeleteModal(true);
    };


    const toggleCompanyStatus = (clientId, currentStatus) => {
        const enable = !currentStatus; 
        const message = enable ? "Are you sure you want to enable this client?" : "Are you sure you want to disable this client?";
    
        showConfirmationAlert(message, () => {
            dispatch(clientStatusUpdate({ clientId, enable }))
              .unwrap()
              .then(() => {
                showSuccessAlert(enable ? "Client enabled successfully!" : "Client disabled successfully!");
                dispatch(getClientList());
              })
              .catch((error) => {
                showErrorAlert(error.message || "Error updating client status");
              });
              
        });

    };
    
    
    

    const handleDeleteCompanyList = () => {
        if (company) {
            dispatch(deleteClient(company.id));
            setDeleteModal(false);
        }
    };

    const activebtn = (ele) => {
        if (ele.closest("button").classList.contains("active")) {
            ele.closest("button").classList.remove("active");
        } else {
            ele.closest("button").classList.add("active");
        }
    };

    const calculateProgress = (userCount) => {
        const maxUserCount = 20;
        return userCount;
    };

    const handleAddNewCompany = () => {
        dispatch(createClient({
            name: newCompany.name,
            email: newCompany.email,
            type: newCompany.type,
            base64Image: newCompany.base64Image || null
        }));
        setAddModal(false);
    };

    const handleEditCompany = () => {
        dispatch(updateClient({
            clientId: company.id, clientData: {
                name: company.name,
                email: company.email,
                type: company.type,
                base64Image: company.base64Image || null
            }
        }));
        setEditModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCompany({ ...newCompany, [name]: value });
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setCompany({ ...company, [name]: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setNewCompany({ ...newCompany, base64Image: reader.result });
        };
        reader.readAsDataURL(file);
    };

    const handleEditImageChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setCompany({ ...company, base64Image: reader.result });
        };
        reader.readAsDataURL(file);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;


    const filteredCompanies = companies?.filter(company =>
        company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const currentItems = filteredCompanies?.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredCompanies?.length / itemsPerPage);

    const handleClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} />
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} backdrop="static">
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Delete Company</ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this company?
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => handleDeleteCompanyList()}>Delete</Button>
                    <Button color="secondary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={addModal} toggle={() => setAddModal(!addModal)}>
                <ModalHeader toggle={() => setAddModal(!addModal)}>Add New Company</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="name">Company Name</Label>
                        <Input type="text" name="name" id="name" value={newCompany.name} onChange={handleInputChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Caption (Email)</Label>
                        <Input type="text" name="email" id="email" value={newCompany.email} onChange={handleInputChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="type">Type</Label>
                        <Input type="text" name="type" id="type" value="BASIC" disabled />
                    </FormGroup>
                    <FormGroup>
                        <Label for="base64Image">Company Image</Label>
                        <Input type="file" name="base64Image" id="base64Image" onChange={handleImageChange} />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAddNewCompany}>Add Company</Button>{' '}
                    <Button color="secondary" onClick={() => setAddModal(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModal} toggle={() => setEditModal(!editModal)}>
                <ModalHeader toggle={() => setEditModal(!editModal)}>Edit Company</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="name">Company Name</Label>
                        <Input type="text" name="name" id="name" value={company?.name || ''} onChange={handleEditInputChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Caption (Email)</Label>
                        <Input type="text" name="email" id="email" value={company?.email || ''} onChange={handleEditInputChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="type">Type</Label>
                        <Input type="text" name="type" id="type" value="BASIC" disabled />
                    </FormGroup>
                    <FormGroup>
                        <Label for="base64Image">Company Image</Label>
                        <Input type="file" name="base64Image" id="base64Image" onChange={handleEditImageChange} />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleEditCompany}>Update Company</Button>{' '}
                    <Button color="secondary" onClick={() => setEditModal(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Company Admin" pageTitle="Admin" />
                    <Row className="g-4 mb-3">
                        <div className="col-sm-auto">
                            <div>
                                <Button color="success" onClick={() => setAddModal(true)}>
                                    <i className="ri-add-line align-bottom me-1"></i> Add New
                                </Button>
                            </div>
                        </div>
                        <div className="col-sm-3 ms-auto">
                            <div className="d-flex justify-content-sm-end gap-2">
                                <div className="search-box ms-2 col-sm-7">
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <i className="ri-search-line search-icon"></i>
                                </div>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        {loading ? (
                            <div style={{ paddingTop: '15%', paddingBottom: '15%' }}>
                                <Loader error={error} />
                            </div>

                        ) : error ? (
                            <div className="d-flex justify-content-center mx-2 mt-2">
                                <i className="mdi mdi-alert-circle-outline fs-24 text-danger me-2"></i>
                                <span className="text-danger">{error}</span>
                            </div>
                        ) : (
                            Array.isArray(companies) && currentItems.map((item, index) => (
                                <Col xxl={3} sm={6} className="project-card" key={index}>
                                    <Card className="card-height-100">
                                        <CardBody>
                                            <div className="d-flex flex-column h-100">
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <div className="d-flex gap-1 align-items-center">

                                                        <Badge color={item.enable ? "success" : "danger"}>
                                                            {item.enable ? "Active" : "Inactive"}
                                                        </Badge>
                                                            <button type="button" className="btn avatar-xs mt-n1 p-0 favourite-btn" onClick={(e) => activebtn(e.target)}>
                                                                <span className="avatar-title bg-transparent fs-15">
                                                                    <i className="ri-star-fill"></i>
                                                                </span>
                                                            </button>

                                                            
                                                            <UncontrolledDropdown direction='start'>
                                                                <DropdownToggle tag="button" className="btn btn-link text-muted p-1 mt-n2 py-0 text-decoration-none fs-15">
                                                                    <FeatherIcon icon="more-horizontal" className="icon-sm" />
                                                                </DropdownToggle>

                                                                <DropdownMenu className="dropdown-menu-end">
                                                                    <DropdownItem href="#" onClick={() => goToCompanyDetail(item)}>
                                                                        <i className="ri-eye-fill align-bottom me-2 text-muted"></i> View
                                                                    </DropdownItem>

                                                                    <DropdownItem href="#" onClick={() => { setCompany(item); setEditModal(true); }}><i className="ri-pencil-fill align-bottom me-2 text-muted"></i> Edit</DropdownItem>
                                                                    <div className="dropdown-divider"></div>
                                                                    <DropdownItem href="#" onClick={() => toggleCompanyStatus(item.id, item.enable)}>
    <i className={item.enable ? "ri-close-circle-line align-bottom me-2 text-muted" :"ri-checkbox-circle-line align-bottom me-2 text-muted" }></i>
    {item.enable ? "Disable" : "Enable"}
</DropdownItem>

                                                                    <DropdownItem href="#" onClick={() => onClickData(item)}>
                                                                        <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Remove
                                                                    </DropdownItem>

                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex mb-2">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div className="avatar-sm">
                                                            {item.base64Image ? (
                                                                <img src={item.base64Image} alt="" className="img-fluid rounded" />
                                                            ) : (
                                                                <span className={"avatar-title rounded p-2 bg-" + item.imgbgColor + "-subtle"}>
                                                                    <img src={item.base64Image} alt="" className="img-fluid p-1" />
                                                                </span>
                                                            )}
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h5 className="mb-1 fs-15">
                                                            <Link
                                                                to={`/company-detail/${item.id}`}
                                                                state={{ companyData: item }}
                                                                className="text-body"
                                                            >
                                                                {item.name}
                                                            </Link>
                                                        </h5>

                                                        <p className="text-muted text-truncate-two-lines mb-3">{item.email}</p>

                                                    </div>
                                                </div>
                                                <div className="mt-auto">
                                                    <div className="d-flex mb-2">
                                                        <div className="flex-grow-1">
                                                            <div>User Count</div>
                                                        </div>
                                                        <div className="flex-shrink-0">
                                                            <div>{item.userCount}/20</div>
                                                        </div>
                                                    </div>
                                                    <div className="progress progress-sm animated-progess">
                                                        <div className="progress-bar bg-success"
                                                            role="progressbar" aria-valuenow={calculateProgress(item.userCount)} aria-valuemin="0" aria-valuemax="20"
                                                            style={{ width: `${calculateProgress(item.userCount) / 20 * 100}%` }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        )}
                    </Row>

                    <Row className="g-0 text-center text-sm-start align-items-center mb-4">
                        <Col sm={6}>
                            <div>
                                <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">{indexOfFirstItem + 1}</span> to <span className="fw-semibold">{Math.min(indexOfLastItem, companies?.length)}</span> of <span className="fw-semibold text-decoration-underline">{companies?.length}</span> entries</p>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <Link to="#" className="page-link" onClick={() => handleClick(currentPage - 1)}>Previous</Link>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li className={`page-item ${currentPage === i + 1 ? 'active' : ''}`} key={i}>
                                        <Link to="#" className="page-link" onClick={() => handleClick(i + 1)}>{i + 1}</Link>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <Link to="#" className="page-link" onClick={() => handleClick(currentPage + 1)}>Next</Link>
                                </li>
                            </ul>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default CompanyAdmin;
